<template>
    <div class="wrapper">
        <NavBar />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="container-fluid py-2" style="background-color: white !important;">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-12 text-center wow fadeInDown">
                            <img :src="folder" alt="User Profil" class="img-size-50 mr-3 img-circle shake-element"
                                style="height: 80px !important;width: 80px !important;"><br><br>
                            <h5>Halo {{ sapaan }}, <span class="text-success">{{ namauser }}</span>, {{
                                jabatanuser }}
                            </h5>
                            <div class="row">
                                <div class="col-sm-2 text-center"></div>
                                <div class="col-sm-8 text-center">
                                    <div class="card" style="background-color: rgba(255, 255, 255, 0.1)">
                                        <div class="row py-2 px-2">
                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                {{ hasil }} {{ hariAngka }}
                                            </div>
                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                <div class="row py-2 px-2">
                                                    <div class="col-sm-12 text-center bgbiru">
                                                        <h2 class="text-white">Pengajuan Izin</h2>
                                                    </div>
                                                    <div class="col-sm-12 text-center">&nbsp;</div>
                                                    <div class="col-sm-4 text-left">
                                                        <label>Jenis Pengajuan<small class="text-info"> (*wajib
                                                                dipilih)</small></label>
                                                        <v-select :options="status" :reduce="(label) => label.code"
                                                            label="label" v-model="defaultSelectedstatus"
                                                            @update:modelValue="onstatusChange"
                                                            style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                                    </div>
                                                    <div class="col-sm-4 text-left">
                                                        <label>Dari Tanggal<small class="text-info"> (*wajib
                                                                diisi)</small></label>
                                                        <div class="input-group mb-3">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text"><i
                                                                        class="fab fa-creative-commons-share"></i></span>
                                                            </div>
                                                            <input type="date" class="form-control form-control-sm"
                                                                id="dari_tanggal" name="dari_tanggal"
                                                                placeholder="Tanggal Mulai" v-model="dari_tanggal">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4 text-left">
                                                        <label>Sampai Tanggal<small class="text-info"> (*wajib
                                                                diisi)</small></label>
                                                        <div class="input-group mb-3">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text"><i
                                                                        class="fab fa-creative-commons-share"></i></span>
                                                            </div>
                                                            <input type="date" class="form-control form-control-sm"
                                                                id="sampai_tanggal" name="sampai_tanggal"
                                                                placeholder="Tanggal Selesai" v-model="sampai_tanggal">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 text-left">
                                                        <label>Keterangan</label>
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <quill-editor v-model:value="keterangan"
                                                                    style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 text-center">&nbsp;</div>
                                                    <div class="col-sm-4 text-center"></div>
                                                    <div class="col-sm-4 text-center">
                                                        <button type="button"
                                                            class="btn btn-primary btn-sm text-white lebar2"
                                                            @click="prosesdata()" data-toggle="tooltip"
                                                            data-placement="left" title="Lihat data..">
                                                            <i class="fas fa-calendar-alt"></i> Ajukan Izin / Cuti
                                                        </button>
                                                    </div>
                                                    <div class="col-sm-4 text-center"></div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 text-center"></div>
                            </div>
                        </div><!-- /.col -->
                        <div class="col-sm-12 text-center">&nbsp;</div>
                        <div class="col-sm-12 text-center">&nbsp;</div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import Footer from "../componen/FooterAksi.vue";
import NavBar from "../componen/NavBarAksi.vue";
import Menu from "../componen/Menu.vue";
import swal from 'sweetalert2';
import VueApexCharts from "vue3-apexcharts";
import { quillEditor } from 'vue3-quill';
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };

export default {
    components: {
        Footer, NavBar, Menu, vSelect, apexchart: VueApexCharts, quillEditor, swal,
    },
    data() {
        return {
            halamanloading: true,
            showFilter: true,
            iduser: JSON.parse(localStorage.getItem("isistemaksi")),
            leveluser: JSON.parse(localStorage.getItem("lsistemaksi")),
            namauser: JSON.parse(localStorage.getItem("namasistemaksi")),
            jabatanuser: JSON.parse(localStorage.getItem("jabatansistemaksi")),
            tokensistemaksi: JSON.parse(localStorage.getItem("tokensistemaksi")),
            datapesan: '',
            sapaan: '',
            datamaster: [],
            carikata: '',
            datatahun: [],
            tahun: [],
            defaultSelectedtahun: {},
            selectedtahun: new Date().getFullYear(),
            jam: '',
            menit: '',
            detik: '',
            hasil: '',
            hariAngka: '',
            statusjam: '',
            timer: null,
            folder: process.env.VUE_APP_URL_API + 'androidAbsensi-Gambar?f=' + JSON.parse(localStorage.getItem("ikonsistemaksi")),
            latitude: '',
            longitude: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            jam_masuk: '',
            jam_pulang: '',
            tanggal_masuk: '',
            tanggal_pulang: '',
            tipe: '',
            id: '',
            ket: '',
            class: '',
            proses: '',
            durasi: '',
            jamdurasi: 0,
            menitdurasi: 0,
            detikdurasi: 0,
            linknya: process.env.VUE_APP_URL_API,
            dari_tanggal: '',
            sampai_tanggal: '',
            status: [],
            datastatus: [],
            defaultSelectedstatus: {
                code: 0,
                label: 'Pilih Pengajuan',
                tag: '',
            },
            selectedstatus: '',
            keterangan: '',
            validasi: false,
        }
    },
    methods: {
        validasidata() {
            if ((this.selectedstatus == '') || (this.selectedstatus === null) || (this.selectedstatus === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Jenis Pengajuan..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        prosesdata() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            swal.fire({
                title: "Konfirmasi",
                text: "Data sudah benar?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Belum",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Sudah"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.halamanloading = true;
                    var fd = new FormData();
                    fd.append("id_user", this.iduser);
                    fd.append("dari_tanggal", this.dari_tanggal);
                    fd.append("sampai_tanggal", this.sampai_tanggal);
                    fd.append("status", this.selectedstatus);
                    fd.append("keterangan", this.keterangan);
                    fd.append("project_id", this.project_id);

                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            "Content-Type": "form-data",
                            Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                        },
                    });
                    mainAPI.post("androidAbsensi-PengajuanAbsensi", fd).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data ajuan telah tersimpan, proses akan dilanjutkan oleh administrator..', 'success').then(function () {
                                    window.location.replace("/Izin");
                                });
                                $('.swal2-container').css("z-index", '999999');
                            }
                        }
                    ).catch(function (error) {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: error
                        });
                    }
                    )
                }
            });
        },
        LihatWaktu() {
            this.timer = setInterval(() => {
                var jam = new Date().getHours();
                if (jam < 12) {
                    this.sapaan = "Selamat Pagi";
                } else if (jam < 15) {
                    this.sapaan = "Selamat Siang";
                } else if (jam < 19) {
                    this.sapaan = "Selamat Sore";
                } else {
                    this.sapaan = "Selamat Malam";
                }

                var now = new Date();

                this.jam = now.getHours();
                this.menit = now.getMinutes();
                this.detik = now.getSeconds();
                this.jam = (this.jam < 10) ? "0" + this.jam : this.jam;
                this.menit = (this.menit < 10) ? "0" + this.menit : this.menit;
                this.detik = (this.detik < 10) ? "0" + this.detik : this.detik;

                this.hariAngka = 'Jam: ' + this.jam + ':' + this.menit + ':' + this.detik; // 0 (Minggu) - 6 (Sabtu) [10]
                //this.durasi = this.jamdurasi + ':' + this.menitdurasi + ':' + this.detikdurasi; // 0 (Minggu) - 6 (Sabtu) [10]
                var tanggal = now.getDate(); // 1 - 31 [2]
                var bulan = now.getMonth(); // 0 - 11 [2]
                var tahun = now.getFullYear(); // 4 digit tahun [2]

                // Array nama hari dan bulan (opsional, untuk hasil dalam Bahasa Indonesia)
                var namaHari = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
                var namaBulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

                // Format: "Selasa, 3 Februari 2026"
                this.hasil = namaHari[now.getDay()] + ", " + tanggal + " " + namaBulan[bulan] + " " + tahun;

            }, 1000);
        },
        async ambilmaster() {
            this.halamanloading = true;

            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistemaksi"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("JenisAjuan-GetData?random=" + random + "&project_id=" + this.project_id + "&selain=4").then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datastatus = [];
                        this.status = [];
                        this.datastatus = Response.data.content.data;
                        this.datastatus.forEach((item) => {
                            this.status.push({
                                label: item.nama,
                                code: this.datastatus.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.status.unshift({
                            label: 'Pilih Pengajuan',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            })
        },
        onstatusChange(a) {
            try {
                this.selectedstatus = this.status[a].tag;
            }
            catch (err) {
                return;
            }
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorageAksi();
                }
            });

            return false;
        },
    },
    mounted() {
        this.ambilmaster();
        this.LihatWaktu();
        var bulan = new Date().getMonth() + 1;
        bulan = (bulan < 10) ? "0" + bulan : bulan;
        this.dari_tanggal = new Date().getFullYear() + '-' + bulan + '-' + new Date().getDate();
        this.sampai_tanggal = new Date().getFullYear() + '-' + bulan + '-' + new Date().getDate();
        this.halamanloading = false;
    }
}
</script>
<style></style>